import React, { memo } from 'react';
import { useStyles } from './styles';

export type StatusChipVariant = 'green' | 'yellow' | 'red' | 'gray';

export interface IStatusChipProps {
  label: string;
  variant: StatusChipVariant;
}

const StatusChip = ({ label, variant }: IStatusChipProps) => {
  const classes = useStyles();
  return <span className={`${classes.root} ${classes[variant]}`}>{label}</span>;
};

export default memo(StatusChip);
